import { useEffect, useState } from "react";

// Same window.innerWidth < 768 pattern already used ad hoc in
// crm-pages/conversation/index.tsx — pulled out into one shared hook so the
// marketing and CRM layouts (and anything else) don't each reinvent it.
export default function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(() => (typeof window !== "undefined" ? window.innerWidth < breakpoint : false));

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);

  return isMobile;
}
